import { registerAction } from '../../Action'

const REGISTER_DRAGGED_MOMENT = 'REGISTER_DRAGGED_MOMENT'

const reducer = (state = {}, action) => ({
  ...state,
  draggedMoment: action.payload,
})

const registerDraggedMoment = registerAction(REGISTER_DRAGGED_MOMENT, {
  reducer,
})

export default registerDraggedMoment
